import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";

import AuthService from "./services/auth.services";

import Login from "./components/Login";
import Register from "./components/Register";
import PortalShell from "./components/Portal/PortalShell";

import { useDispatch, useSelector } from "react-redux";
import PrivateRoute from "./common/PrivateRoute";
import PageNotFound from "./components/PageNotFound";
import { setAuth, setUser } from "./redux/commonSlice";

const App = () => {
  // const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  // const [showAdminBoard, setShowAdminBoard] = useState(false);
  const isAuthenticating = useSelector(state => state.common.auth.isAuthenticating);
  const isAuthenticated = useSelector(state => state.common.auth.isAuthenticated);


  const dispatch = useDispatch();


  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      dispatch(setUser(user));
      // setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
      // setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }
    dispatch(setAuth({ isAuthenticating: false, isAuthenticated: !!user }));




    // EventBus.on("logout", () => {
    //   logOut();
    // });

    // return () => {
    //   EventBus.remove("logout");
    // };
    // eslint-disable-next-line no-use-before-define
  }, [dispatch]);

  return (
    <div>
      <div style={{ width: "100%" }}>
        <Routes>
          <Route exact path={"/login"} element={<Login />} />
          <Route exact path={"/register"} element={<Register />} />

          <Route exact path={"/"} element={<Navigate to="/app" />} />
          <Route exact path={"/app"} element={<PrivateRoute isAuthenticating={isAuthenticating} isAuthenticated={isAuthenticated}><PortalShell /></PrivateRoute>} />
          <Route path="*" element={<PageNotFound />} />

          {/* <Route path="/user" element={<BoardUser />} /> */}
          {/* <Route path="/mod" element={<BoardModerator />} />
          <Route path="/admin" element={<BoardAdmin />} /> */}
        </Routes>
      </div>


    </div>
  );
};

export default App;
